import styles from "./PaymentResultPopup.module.scss";
import React from "react";
import successIcon from "../../../assets/images/icons/success-meassage-icon.svg";
import errorIcon from "../../../assets/images/icons/error-message-icon.svg";
import { useTranslation } from "react-i18next";

interface IPaymentResultPopupProps {
  type: "success" | "failed";
  closeFn: () => void;
}

const PaymentResultPopup: React.FC<IPaymentResultPopupProps> = ({ type, closeFn }) => {
  const { t } = useTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.popup}>
        {type === "success" && (
          <>
            <img src={successIcon} alt={"Success"} />
            <h2>{t("PaymentSuccessful")}</h2>
            <p>{t("YourPaymentHasBeenSuccessfullyProcessed")}</p>
          </>
        )}
        {type === "failed" && (
          <>
            <img src={errorIcon} alt={"Failed"} />
            <h2>{t("PaymentFailed")}</h2>
            <p>{t("WeAreSorryButYourPaymentCouldNotBeProcessedAtThisTime")}</p>
          </>
        )}
        <button onClick={closeFn}>{t("Done")}</button>
      </div>
    </div>
  );
};

export default PaymentResultPopup;
